<template>
  <div class="amount-tile" :class="tone ? `amount-tile--${tone}` : ''">
    <span>
      {{ label }}
      <q-icon v-if="hint" name="info_outline" class="hint-icon" />
    </span>
    <strong>{{ formatted }}</strong>
    <q-tooltip v-if="hint" max-width="340px" anchor="top middle" self="bottom middle">
      {{ hint }}
    </q-tooltip>
  </div>
</template>

<script>
export default {
  name: "UspReportAmountTile",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: null },
    tone: { type: String, default: "" },
    signed: Boolean,
    hint: { type: String, default: "" },
  },
  computed: {
    formatted() {
      if (this.value === null || this.value === undefined) return "—";
      const number = Number(this.value);
      const sign = this.signed && number > 0 ? "+" : "";
      return `${sign}${new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number)} ₸`;
    },
  },
};
</script>

<style scoped>
.amount-tile { padding: 14px; border: 1px solid #e6eaf0; border-radius: 10px; background: #fafbfc; cursor: help; }
.amount-tile span { display: flex; align-items: center; gap: 4px; margin-bottom: 6px; color: #687386; font-size: 12px; }
.hint-icon { font-size: 14px; opacity: .7; }
.amount-tile strong { font-size: 17px; }
.amount-tile--actual { background: #f1f5ff; border-color: #d5e0fa; }
.amount-tile--target { background: #eef9f3; border-color: #cdebd9; }
.amount-tile--danger { background: #fff3f3; border-color: #f2caca; color: #a82533; }
.amount-tile--ok { background: #eef9f3; border-color: #cdebd9; color: #147742; }
</style>
